//@flow
import React from 'react';
import {ButtonBase, Typography, makeStyles} from '@material-ui/core';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {colors} from '../../../../assets/styles/colors';

import ReceiptQuoteIcon from '../../../../elements/icons/ReceiptQuoteIcon';
import ReceiptLongIcon from '../../../../elements/icons/ReceiptLongIcon';

import type {Theme} from '@material-ui/core';

type Props = {
  open: boolean,
  onClose: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '380px',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
  },
  body: {
    display: 'flex',
    gap: '1rem',
  },
  button: {
    width: '100%',
    height: 'auto',
    aspectRatio: '1',
    borderRadius: '1rem',
    border: `solid 1px ${colors.primary}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '1rem',
    gap: '.5rem',
    cursor: 'pointer',
    fontWeight: 600,
  },
  buttonIcon: {
    fontSize: '1.75rem',
    padding: '.75rem',
    borderRadius: '50%',
    background: `${colors.primary}29`,
    color: colors.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonLabel: {
    fontSize: '.875rem',
  },
}));

export default function DownloadTaxInvoiceModal(props: Props) {
  const {open, onClose} = props;

  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={onClose}>
      <div className={classes.root}>
        <Typography>Descargar documentos</Typography>

        <div className={classes.body}>
          <ButtonBase className={classes.button}>
            <span className={classes.buttonIcon}>
              <ReceiptQuoteIcon />
            </span>
            <Typography className={classes.buttonLabel}>
              Descargar Factura
            </Typography>
          </ButtonBase>
          <ButtonBase className={classes.button}>
            <span className={classes.buttonIcon}>
              <ReceiptLongIcon />
            </span>
            <Typography className={classes.buttonLabel}>
              Descargar Boleta
            </Typography>
          </ButtonBase>
        </div>
      </div>
    </CustomModal>
  );
}
